import { Component, Prop, Vue } from 'vue-property-decorator';
import { NumberedString } from './types';

@Component
export default class ComponentsPartsBlogListMixin extends Vue {
  // Props
  @Prop({ type: String, default: '' })
  code: string;

  @Prop({ type: String, default: '' })
  name: string;

  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: String, default: '' })
  desc: string;

  @Prop({ type: String, default: '' })
  event_type: string;

  @Prop({ type: String, default: '' })
  littleThumb: string;

  @Prop({ type: String, default: '' })
  middleThumb: string;

  @Prop({ type: String, default: '' })
  text: string;

  @Prop({ type: [String, Number], default: null })
  id: NumberedString;

  @Prop({ type: [String, Number], default: null })
  view: NumberedString;

  @Prop({ type: [String, Number], default: null })
  comments: NumberedString;

  //computed
  get to() {
    const { code, id } = this;
    return {
      name: 'blog-article',
      params: { code, id },
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/blog/mixins/mixin.ts